/* src/components/searchControl/InputChunk.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_store_value,
	space
} from "../../../_snowpack/pkg/svelte/internal.js";

import { inputValues } from '../../stores/storeInputOptions.js';

function create_fragment(ctx) {
	let label;
	let t1;
	let select;
	let option0;
	let option1;
	let option2;
	let mounted;
	let dispose;

	return {
		c() {
			label = element("label");
			label.textContent = "表示件数：";
			t1 = space();
			select = element("select");
			option0 = element("option");
			option0.textContent = "20件";
			option1 = element("option");
			option1.textContent = "40件";
			option2 = element("option");
			option2.textContent = "60件";
			attr(label, "for", "sb_limit");
			option0.__value = "20";
			option0.value = option0.__value;
			option0.selected = "selected";
			option1.__value = "40";
			option1.value = option1.__value;
			option2.__value = "60";
			option2.value = option2.__value;
			attr(select, "id", "sb_limit");
			attr(select, "name", "limit");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			insert(target, t1, anchor);
			insert(target, select, anchor);
			append(select, option0);
			append(select, option1);
			append(select, option2);

			if (!mounted) {
				dispose = listen(select, "blur", /*changeOption*/ ctx[0]);
				mounted = true;
			}
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(label);
			if (detaching) detach(t1);
			if (detaching) detach(select);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $inputValues;
	component_subscribe($$self, inputValues, $$value => $$invalidate(1, $inputValues = $$value));

	async function changeOption(e) {
		set_store_value(inputValues, $inputValues['limit'] = e.target.value, $inputValues);
	}

	return [changeOption];
}

class InputChunk extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default InputChunk;